import { render, staticRenderFns } from "./uOttawaTAEvaluationsV2Fr.vue?vue&type=template&id=4be78f53&scoped=true&"
import script from "./uOttawaTAEvaluationsV2Fr.vue?vue&type=script&lang=ts&"
export * from "./uOttawaTAEvaluationsV2Fr.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be78f53",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VRow})
